export const CODEC_HELP = "This video can't be played here — the file may be unreachable, or it uses a codec this browser can't decode (e.g. HEVC/H.265). If the file plays on your computer, re-export it as an H.264 MP4 and re-upload; otherwise refresh and try again.";

export const CORRUPT_FILE_HELP = "This file isn't a readable video — if it lives in OneDrive/Google Drive/iCloud it may not be fully synced. Copy it to a local folder (e.g. Downloads), confirm it plays there, then upload that copy.";

// Fast magic-bytes sniff: does this file even have a video container header?
// Catches unsynced cloud-drive placeholders and corrupt blobs before upload.
export async function sniffVideoContainer(file) {
  try {
    const head = new Uint8Array(await file.slice(0, 64).arrayBuffer());
    const ascii = Array.from(head).map((b) => (b > 31 && b < 127 ? String.fromCharCode(b) : ".")).join("");
    if (ascii.slice(4, 8) === "ftyp") return true; // mp4 / mov / m4v
    if (head[0] === 0x1a && head[1] === 0x45 && head[2] === 0xdf && head[3] === 0xa3) return true; // webm / mkv
    if (ascii.startsWith("RIFF")) return true; // avi
    if (ascii.startsWith("OggS")) return true; // ogg
    return false;
  } catch {
    return false;
  }
}

// Load the local file into a hidden <video> and confirm the browser can actually decode a frame.
export function checkVideoDecodable(file) {
  return new Promise((resolve) => {
    let done = false;
    const url = URL.createObjectURL(file);
    const v = document.createElement("video");
    const finish = (ok) => {
      if (done) return;
      done = true;
      URL.revokeObjectURL(url);
      try { v.removeAttribute("src"); v.load(); } catch { /* noop */ }
      resolve(ok);
    };
    v.preload = "auto";
    v.muted = true;
    v.playsInline = true;
    v.onloadeddata = () => finish(v.videoWidth > 0 && v.videoHeight > 0);
    v.onerror = () => finish(false);
    setTimeout(() => finish(false), 12000);
    v.src = url;
  });
}
